module.exports = __webpack_public_path__ + "static/media/Query_black.4e0e5007.svg";